import { useMemo } from "react";
import { ReactComponent as Doc } from "../../../assets/images/fileManager/documentIcon.svg";
import { ENVIRONMENT } from "../../../environment";
import { planResourceType } from "../../../interfaces/general";
import { UnitConvertStandard } from "../../../scripts/helpers";
import { PaymentInformationType, PaymentStatusEnum } from "./ConfirmPlan.index";

type Props = {
    resource: planResourceType;
    paymentInformation: PaymentInformationType;
    price: number;
    taxPercent: number;
    finalPrice: number;
};

export default function PlanConfirmCard(props: Props) {
    const { resource, paymentInformation, taxPercent, price } = props;
    const planPrice = (resource.price * (1 - resource.discount)) / 10;
    const originalPrice = useMemo(() => planPrice + (planPrice * taxPercent) / 100, [resource]);

    return (
        <div className="lg:min-w-[400px] w-full flex flex-col p-6 bg-white rounded-lg">
            <div className="flex justify-start items-center px-1">
                <div>
                    <Doc />
                </div>
                <div className="text-base text-secondary-800 font-medium pr-3">{`جزئیات خرید فضای ابری ${ENVIRONMENT.brandName}`}</div>
            </div>
            <div className="flex justify-between items-center px-2 pb-2 pt-4">
                <div className="font-normal text-sm text-secondary-600">{"حجم فضای ابری"}</div>
                <div className="font-normal text-xs md:text-sm">
                    {Math.ceil(UnitConvertStandard(resource.volume, "fa").value) + ` ${UnitConvertStandard(resource.volume, "fa").unit}`}
                </div>
            </div>
            <div className="flex justify-between items-center p-2">
                <div className="font-normal text-xs md:text-sm text-secondary-600">{"زمان فضای ابری"}</div>
                <div className="font-normal text-xs md:text-sm">{resource.duration ? `${resource.duration} روزه` : "معین نگردیده"}</div>
            </div>
            <div className="flex justify-between items-center p-2">
                <div className="flex items-center gap-1 font-normal text-xs md:text-sm text-secondary-600">
                    <div>{"هزینه فضای ابری"}</div>
                </div>
                <div className="font-normal text-xs md:text-sm">
                    <>
                        <span>{price?.toLocaleString()}</span>
                        <span className="text-[#989DB8] text-xs md:text-sm font-normal pr-1">{"تومان"}</span>
                    </>
                </div>
            </div>
            <div className="flex justify-between items-center p-2">
                <div className="flex items-center gap-1 font-normal text-xs md:text-sm text-secondary-600">
                    <div>{`مالیات بر ارزش افزوده (%${taxPercent})`}</div>
                </div>
                <div className="font-normal text-xs md:text-sm">
                    <>
                        <span>{((price! * taxPercent) / 100).toLocaleString()}</span>
                        <span className="text-[#989DB8] text-xs md:text-sm font-normal pr-1">{"تومان"}</span>
                    </>
                </div>
            </div>
            <hr />
            <div className="flex justify-between items-center p-2">
                <div className="font-bold text-xs md:text-sm text-secondary-600">{"مبلغ قابل پرداخت"}</div>
                <div className="font-bold text-sm md:text-base">
                    {(paymentInformation.status === PaymentStatusEnum.WALLET && paymentInformation.wallet.balance) || paymentInformation.voucher ? (
                        <div className="flex items-center gap-4">
                            <span>{props.finalPrice >= 0 ? `${props.finalPrice.toLocaleString()} تومان` : "0 تومان"}</span>
                            {(paymentInformation.voucher || (paymentInformation.wallet && paymentInformation.wallet.balance !== undefined)) && (
                                <del className="text-secondary-500 text-[14px] font-normal">{originalPrice.toLocaleString()} تومان</del>
                            )}
                        </div>
                    ) : (
                        <span>{props.finalPrice.toLocaleString()} تومان</span>
                    )}
                </div>
            </div>
        </div>
    );
}
